import { loadShared } from './dashboardCache';

// What a click on the Tutor Count page opens: the tutors behind a number (see tutor_count_tutors.controller.js on the server).
//   a CRO's "handling now" / "assigned this month" count -> that CRO's tutors
//   the company-wide Active Tutors card                  -> every active tutor
// One place builds the URLs, so the page that PREFETCHES on hover and the popup that LOADS on click share the very same remembered
// answer (dashboardCache.js).
export const TUTOR_KIND_LABEL = { active: 'Tutors handling', new: 'Tutors assigned this month' };

export const tutorCountTutorsUrl = ({ kind, userId, month }) => {
  const params = new URLSearchParams({ kind, userId: String(userId), month: month.format('YYYY-MM-DD') });
  return `warning-dashboard/tutor-count-tutors?${params.toString()}`;
};

export const allTutorsUrl = ({ month }) => `warning-dashboard/tutor-count-all-tutors?month=${month.format('YYYY-MM-DD')}`;

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchTutors = (url) => {
  loadShared(url).catch(() => {});
};
